export default "/images/605abf46b0ad0cf256dacb21ccc0efef.png";